import { FormControl, HStack, Switch } from "@chakra-ui/react"
import { useState } from "react"
import { FormLabel } from "../../common/FormLabel"
import { SessionType } from "../SessionType"
import { StyledSelect } from "../styled"

export const SessionTypeSwitch = ({ value, onChange, isDisabled }) => {
    const [routerSessionType, setRouterSessionType] = useState(
        value === SessionType.RouterDownstream
            ? SessionType.RouterDownstream
            : SessionType.RouterUpstream
        )

    return <FormControl>
    <HStack padding='10px 16px'>
        <Switch
            id="session-type-switch"
            disabled={isDisabled}
            isChecked={value !== SessionType.Simple}
            onChange={(e) => onChange(e.target.checked ? routerSessionType : SessionType.Simple)}
        />
        <FormLabel
            htmlFor="session-type-switch"
            disabled={isDisabled}
        >
            Router
        </FormLabel>
        <StyledSelect
            background='input'
            width={145}
            disabled={isDisabled || value === SessionType.Simple}
            value={routerSessionType}
            onChange={(e) => {
                setRouterSessionType(e.target.value)
                onChange(e.target.value)
            }}
        >
            <option value={SessionType.RouterUpstream}>Upstream</option>
            <option value={SessionType.RouterDownstream}>Downstream</option>
        </StyledSelect>
    </HStack>
    </FormControl>
}